<template>
  <div class="card-recycling">
    <img src="@/assets/注册页面备份.png" alt="Card Recycling" class="card-recycling-image">
    <div class="form-container">
      <div class="form-wrapper">
        <div class="input-group">
          <input v-model="phone" type="text" placeholder="请输入您的手机号码" class="form-input">
        </div>

        <div class="input-group verification-group">
          <input v-model="verificationCode" type="text" placeholder="您的短信验证码"
                 class="form-input verification-input">
          <button @click="sendCode" class="code-button" :disabled="countdown > 0">{{
              countdown > 0 ? `${countdown}s` :
                  '发送验证码'
            }}
          </button>
        </div>

        <button @click="submit" class="submit-button">提交</button>
      </div>
    </div>

    <div v-if="showSuccessModal" class="modal-overlay">
      <div class="modal-content">
        <img class="qr-code" src="@/assets/下载.png" alt="QR Code">
        <p class="modal-text">APP下载地址</p>
        <button class="close-button" @click="showSuccessModal = false">×</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount} from 'vue'
import http from '@/api/request';
// 初始化 axios
// import axios from 'axios'

//手机号
const phone = ref('')
// 验证码
const verificationCode = ref('')
//  倒计时
const countdown = ref(0)
//  倒计时
let timer = null
//  邀请码
const inviteCode = ref('')
// 显示成功弹窗
const showSuccessModal = ref(false)
onMounted(() => {
  document.title = "惠收卡";
  let code = ''
  const urlParams = new URLSearchParams(window.location.search)
  code = urlParams.get('inviteCode')
  //  从URL中获取邀请码
  if (!code && window.location.hash) {
    const hashParams = new URLSearchParams(window.location.hash.substring(1))
    code = hashParams.get('inviteCode')
  }
  if (!code && window.location.pathname.includes('inviteCode')) {
    const pathParts = window.location.pathname.split('inviteCode=')
    if (pathParts.length > 1) {
      code = pathParts[1].split('&')[0]
    }
  }
  inviteCode.value = code || ''
})
// 卸载时清除定时器

onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})
//  验证手机号
const validatePhone = () => {
  const phoneRegex = /^1[3-9]\d{9}$/
  return phoneRegex.test(phone.value)
}
//  发送验证码倒计时
const startCountdown = () => {
  countdown.value = 60
  timer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--
    } else {
      clearInterval(timer)
    }
  }, 1000)
}
// 发送验证码
const sendCode = () => {
  if (!validatePhone()) {
    alert('请输入正确的手机号码');
    return;
  }
  http.get('/user/register/captcha', {params: {mobile: phone.value}})
      .then((response) => {
        if (response.data.code == 200) {
          startCountdown();
        } else {
          alert(response.data.msg);
        }
      })
      .catch((error) => {
        console.error(error);
        alert('验证码发送失败，请稍后重试');
      });
};
// 提交表单
const submit = () => {
  if (!validatePhone()) {
    alert('请输入正确的手机号码');
    return;
  }
  if (!verificationCode.value) {
    alert('请输入验证码');
    return;
  }
  http.post('/user/invite/register', {
    mobile: phone.value,
    captcha: verificationCode.value,
    inviteCode: inviteCode.value,
    platform: 3,
  })
      .then((response) => {
        if (response.data.code == 200) {
          showSuccessModal.value = true;
        } else {
          alert(response.data.msg);
        }
      })
      .catch((error) => {
        console.error(error);
        alert('注册失败，请稍后重试');
      });
};
</script>

<style scoped>
.card-recycling {
  width: 100%;
  height: 865px;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #2196f3;
}

.card-recycling-image {
  width: 100vw;
  height: 865px;
}

.form-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 550px;
  margin: 0px 10px;
  border-radius: 20px;
  margin-top: 5px;
}

.form-wrapper {
  background-color: white;
  margin: 0px 23px;
  height: 265px;
  padding: 30px;
  border-radius: 30px;
}

.input-group {
  display: flex;
  margin-bottom: 15px;
  position: relative;
}

.form-input {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 10px;
  background-color: rgba(227, 242, 253, 0.5);
  color: #333;
  font-size: 14px;
}

.verification-group {
  display: flex;
}

.verification-input {
  flex: 1;
  padding-right: 110px;
}

.code-button {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 15px;
  background-color: #ffc107;
  color: #333;
  border: none;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  white-space: nowrap;
  font-weight: bold;
  font-size: 14px;
}

.code-button:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

.submit-button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(to right, #ffcc00, #ffb000);
  color: #333;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 25px;
  box-shadow: 0 3px 8px rgba(255, 176, 0, 0.3);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 15px;
  position: relative;
  width: 80%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code {
  width: 200px;
  height: 200px;
  margin-bottom: 15px;
}

.modal-text {
  color: #333;
  font-size: 16px;
  margin: 0;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border: none;
  background: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.close-button:hover {
  color: #333;
}
</style>
